import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

// element ui
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/reset.css'
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/zh-TW'
Vue.use(ElementUI, { locale })

import 'core-js/stable'
import 'regenerator-runtime/runtime'

// custom css
import './assets/styles/index.scss'

// Global Component
import ElSpace from '@C/Common/ElSpace.vue'
import HPButton from '@C/Common/HPButton.vue'
import Dialog from './components/Common/Dialog.vue'
import MessageDialog from './components/Common/MessageDialog.vue'
import HPEditor from './components/Common/HPEditor.vue'
import AlarmDialog from './components/Common/alarmDialog.vue'
import HPEditorHtml from './components/Common/HPEditorHtml.vue'
import serviceProvideMsg from './components/Common/ServiceProvideMsg.vue'
Vue.component('el-space', ElSpace)
Vue.component('HPButton', HPButton)
Vue.component('Dialog', Dialog)
Vue.component('MessageDialog', MessageDialog)
Vue.component('HPEditor', HPEditor)
Vue.component('AlarmDialog', AlarmDialog)
Vue.component('HPEditorHtml', HPEditorHtml)
Vue.component('serviceProvideMsg', serviceProvideMsg)

// messagebox
import messageBox from './plugins/messagebox'
Vue.prototype.messageBox = messageBox

// 取得 ./assets/images/icons 底下所有 svg 圖檔
const requireAll = (requireContext) => requireContext.keys().map(requireContext)
const req = require.context('./assets/images/icons', true, /\.svg$/)
requireAll(req)

import SvgIcon from '@C/Common/SvgIcon.vue'
Vue.component('SvgIcon', SvgIcon)

Vue.config.productionTip = false
store.commit('userModule/setUserinfo') //設定帳戶資料

// Directive

let tooltipStyle = {
  display: 'none',
  zIndex: '9999',
  position: 'fixed',
  background: '#E6E6E6',
  boxShadow: '2px 4px 4px 0px rgba(0, 0, 0, 0.07)',
  color: '#000',
  padding: '10px',
  borderRadius: '5px'
}

Vue.directive('tooltip', {
  bind(el, bindings) {
    let div = document.createElement('div')

    el.tooltipDiv = div
    document.body.appendChild(div)
    Object.assign(div.style, tooltipStyle)

    el.onmouseenter = (e) => {
      div.style.left = e.pageX + 'px'
      div.style.top = e.pageY + 'px'
      div.style.display = 'block'
      div.textContent = bindings.value
    }

    el.onmouseleave = () => {
      div.style.display = 'none'
    }
  },

  unbind(el) {
    document.body.removeChild(el.tooltipDiv)
    el.onmouseenter = null
    el.onmouseleave = null
  }
})

export const app = new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount('#app')
